import { useState, useEffect } from "react";
import InputField from "./InputField";
import SearchIcon from "@mui/icons-material/Search";
import Button from "./Button";
 
const SearchBar = ({
  data = [],
  searchKey = "name",
  onFilteredData,
  onAddClick,
  placeholder = "Search...",
  buttonLabel = "+ Add"
}) => {
  const [searchTerm, setSearchTerm] = useState("");
 
  // Logic is managed inside: Filters the data whenever searchTerm or data changes
  useEffect(() => {
    const filtered = data.filter((item) => {
      const valueToSearch = item[searchKey] ? item[searchKey].toString().toLowerCase() : "";
      return valueToSearch.includes(searchTerm.toLowerCase());
    });
 
    onFilteredData(filtered);
  }, [searchTerm, data, searchKey, onFilteredData]);
 
  return (
    <div className="row mb-3 align-items-center">
      <div className={onAddClick ? "col-md-10" : "col-12"}>
        <div className="position-relative flex-grow-1">
          <InputField
            type="search"
            inpcls="form-control extrapdng"
            placeholder={placeholder}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <SearchIcon
            style={{
              position: "absolute",
              left: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#6b7280",
              width: "16px",
              height: "16px",
            }}
          />
        </div>
      </div>
 
      {onAddClick && (
        <div className="col-md-2">
          <Button onClick={onAddClick} btncls="w-100 m-0">
            {buttonLabel}
          </Button>
        </div>
      )}
    </div>
  );
};
 
export default SearchBar;